class InvoicePreviewDetail {
    constructor() {
        this.quantity = null;
        this.unitPrice = null;
        this.unitPriceCAD = null;
        this.unitPriceUSD = null;
        this.amount = null;
        this.amountUSD = null;
        this.amountCAD = null;
        this.currencyCode = null;
        this.currencySymbol = null;
        this.name = null;
        this.discount = null;
        this.discountUSD = null;
        this.discountCAD = null;
        this.discountPercent = null;
        this.subTotalAmount = null; // amount - discount
        this.subTotalAmountUSD = null; // amountUSD - discountUSD
        this.subTotalAmountCAD = null; // amountCAD - discountCAD
    }
}
class InvoicePreviewDiscount {
    constructor() {
        this.amount = null;
        this.value = null;
        this.type = null;
        this.currencyCode = null;
        this.currencySymbol = null;
    }
}
class InvoicePreview {
    constructor() {
        /* TotalAmount
         *   The real price of what you are buying (Base Price - Coupon + Taxes)
         *   Might change over time if your coupon only applies to X recurrences of your subscription
         */
        this.totalAmount = null;
        this.totalAmountUSD = null;
        this.totalAmountCAD = null;
        this.baseAmount = null;
        this.baseAmountUSD = null;
        this.baseAmountCAD = null;
        this.subTotalAmount = null;
        this.subTotalAmountUSD = null;
        this.subTotalAmountCAD = null;
        this.taxAmount = null;
        this.taxAmountUSD = null;
        this.taxAmountCAD = null;
        this.totalDiscount = null;
        this.totalDiscountUSD = null;
        this.totalDiscountCAD = null;
        this.discountPercent = null;
        /* DueAmount
         *   The amount the user is going to pay at the moment of the purchase (TotalAmout - Balance/Credit).
         */
        this.dueAmount = null;
        this.discounts = null;
        this.credit = null;
        this.currencyCode = null;
        this.currencySymbol = null;
        this.details = null;
        this.quantity = null;
        this.isTaxComputationSkipped = null;
    }
}
const keysOfInvoicePreview = ["totalAmount", "totalAmountUSD", "totalAmountCAD", "baseAmount", "baseAmountUSD", "baseAmountCAD", "subTotalAmount", "subTotalAmountUSD", "subTotalAmountCAD", "taxAmount", "taxAmountUSD", "taxAmountCAD", "totalDiscount", "totalDiscountUSD", "totalDiscountCAD", "discountPercent", "dueAmount", "discounts", "credit", "currencyCode", "currencySymbol", "details", "quantity", "isTaxComputationSkipped"];

export { InvoicePreview, InvoicePreviewDetail, InvoicePreviewDiscount, keysOfInvoicePreview };
